module.exports = __webpack_public_path__ + "static/netless_white-7bf56f4bda422a2accd3787084153a3a.svg";